import React from "react";
import LoadingPage from "../index";
import PaymentsAppLayout from "../../../Components/Molecules/PaymentsAppLayout";

const PrivateComponentLoadingPage: React.FC = () => {
  return (
    <PaymentsAppLayout>
      <div className="flex flex-col h-[calc(100vh-9rem)]">
        <div className="flex flex-grow flex-col">
          <LoadingPage />
        </div>
      </div>
    </PaymentsAppLayout>
  );
};

export default PrivateComponentLoadingPage;
